import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    channelList: [],
    channelArr: [],
    channelArray: [],
    channelID: "",
    selectedChannel: null,
    isEditing: "",
  };
  
  const mutations = {
    initializeStore(state){
      state.channelList = [];
      state.channelArr = [];
      state.channelArray = [];
      state.channelID = '';
      state.selectedChannel = null;
      state.isEditing = false;
    },
    SET_SELECTED_CHANNEL(state, channel) {
      state.selectedChannel = channel;
      state.isEditing = true;
    },
    CHANNELS_ARRAY(state, channels){
      state.channelArray = channels;
    },
    LIST_MARKETING_CHANNELS(state, channels) {
      state.channelList = channels;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
        
      }
    },
    RESET_SEARCH_FILTERS(state){
      
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createMarketingChannel({ commit,state }, formData) {
      return axios.post('api/v1/create-marketing-channel/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchMarketingChannels({ commit,state }, formData) {
      state.channelArr = [];
      axios.post(`api/v1/get-marketing-channels/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.channelArr.push((response.data[i].name));
        }
        commit('LIST_MARKETING_CHANNELS', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchMarketingChannel({ commit,state }, formData) {
      axios.post(`api/v1/get-marketing-channels/`,formData)
      .then((response)=>{
        state.selectedChannel = response.data;
        commit('SET_SELECTED_CHANNEL',response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedChannel({ commit, state }, option){
      state.channelArray = [];
      const selectedChannel = state.channelList.find(channel => (channel.name) === option);
      if (selectedChannel) {
          state.channelID = selectedChannel.marketing_channel_id;
          state.channelArray = [...state.channelArray, selectedChannel];
      }
      commit('CHANNELS_ARRAY', state.channelArray);
        
    },
  
    async updateMarketingChannel({ commit,state }, formData) {
      return axios.put(`api/v1/update-marketing-channel/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteMarketingChannel({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Channel?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Channel!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-marketing-channel/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Channel removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Channel",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Channel has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  